import { AccountNode } from '../services/apiService';

export function sumBRL(node: AccountNode | undefined): number {
  if (!node) return 0;
  let total = 0;
  for (const [commodity, value] of Object.entries(node.balances)) {
    if (commodity === 'BRL' || commodity === 'R$') {
      total += value;
    }
  }
  return total;
}

export function findAccount(accounts: AccountNode[], name: string): AccountNode | undefined {
  return accounts.find(
    (a) => a.account.toLowerCase() === name.toLowerCase() ||
           a.full_path.toLowerCase() === name.toLowerCase()
  );
}

export function findAccountDeep(accounts: AccountNode[], name: string): AccountNode | undefined {
  for (const a of accounts) {
    if (a.account.toLowerCase() === name.toLowerCase() ||
        a.full_path.toLowerCase() === name.toLowerCase()) {
      return a;
    }
    if (a.children.length > 0) {
      const found = findAccountDeep(a.children, name);
      if (found) return found;
    }
  }
  return undefined;
}

export function getMonthRange(year: number, month: number): { begin: string; end: string } {
  const begin = `${year}-${String(month).padStart(2, '0')}-01`;
  const nextMonth = month === 12 ? 1 : month + 1;
  const nextYear = month === 12 ? year + 1 : year;
  const end = `${nextYear}-${String(nextMonth).padStart(2, '0')}-01`;
  return { begin, end };
}
